module.exports = __webpack_public_path__ + "img/GW.07ac1896.png";